// extracted by mini-css-extract-plugin
export default {"wrapper":"RulesPageFilters_wrapper__1P+PR","line":"RulesPageFilters_line__A89pt"};